var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"primary pa-0",attrs:{"app":""}},[_c('v-card-text',{class:[
      'pa-3',
      'white--text',
      'd-flex',
      'justify-space-between',
      {
        'flex-column': _vm.$vuetify.breakpoint.xs
      }
    ]},[_c('span',{},[_c('strong',[_vm._v("#STAYHOME")])]),_c('span',{},[_c('strong',[_vm._v("#WEARMASKINPUBLIC")])]),_c('span',[_vm._v(" View "),_c('a',{staticClass:"white--text",attrs:{"href":"https://covid19globaltracker.web.app","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" COVID19 vaccine tracker ")])]),_c('span',[_vm._v(" Data from "),_c('a',{staticClass:"white--text",attrs:{"href":"https://disease.sh","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" NOVELCoVID19 API ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }